import { Button } from "@mui/material";
import { CircularLoader, Dropdown } from "@components/index";
import { useChangeClientData } from "./changeClientData";
import "./index.scss";

const ChangeClient = () => {
  const {
    clientOptions,
    selectedClient,
    tempSelectedClient,
    loading,
    isSubmitting,
    handleClientChange,
    handleSubmit,
    handleCancel,
    getCurrentClientName,
  } = useChangeClientData();

  return (
    <div className="change-client-page">
      <div className="change-client-container">
        {/* Header */}
        <div className="change-client-header">
          <h1 className="change-client-title">Change Client</h1>
          <p className="change-client-subtitle">
            Select a different client to view their data
          </p>
        </div>

        <div className="change-client-form-container">
          {loading ? (
            <div className="change-client-loading">
              <CircularLoader
                message="Loading clients..."
                className="change-client-loading-container"
              />
            </div>
          ) : (
            <form className="change-client-form" onSubmit={handleSubmit}>
              {/* Current Client Display */}
              <div className="current-client-info">
                <div className="info-label">Current Client:</div>
                <div className="info-value">{getCurrentClientName()}</div>
              </div>

              {/* Client Selection Dropdown */}
              <div className="form-group">
                <Dropdown
                  label="Select New Client"
                  value={tempSelectedClient}
                  onChange={handleClientChange}
                  options={clientOptions}
                  className="client-dropdown"
                  fullWidth
                />
                <p className="form-helper-text">
                  Changing the client will reload the page with the new client's
                  data
                </p>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <Button
                  type="button"
                  variant="outlined"
                  size="large"
                  className="cancel-button"
                  onClick={handleCancel}
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  className={`submit-button ${isSubmitting ? "loading" : ""}`}
                  disabled={
                    isSubmitting || tempSelectedClient === selectedClient
                  }
                >
                  {isSubmitting ? "Changing..." : "Change Client"}
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChangeClient;
